import React from "react";

// "For each patient you can easily see a list of their claims" — David.
//
// Newest first, with what was billed and what came back. Clicking a row hands the
// claim id up so the ledger can open it; the drawer does not try to be a second
// claim editor.

const STATUS_CLASS = {
  paid: "pt-status-good",
  partial: "pt-status-warn",
  submitted: "pt-status-info",
  accepted: "pt-status-info",
  pending: "pt-status-muted",
  draft: "pt-status-muted",
  rejected: "pt-status-bad",
  denied: "pt-status-bad",
  error: "pt-status-bad",
};

function money(value) {
  if (value === null || value === undefined) return "—";
  return `$${Number(value).toFixed(2)}`;
}

export default function PatientClaims({ claims, onOpenClaim }) {
  if (!claims || claims.length === 0) {
    return (
      <section className="pt-card">
        <div className="pt-card-head">
          <h3>Claims</h3>
        </div>
        <p className="pt-empty">No claims for this patient yet.</p>
      </section>
    );
  }

  return (
    <section className="pt-card">
      <div className="pt-card-head">
        <h3>Claims</h3>
      </div>
      <div className="pt-table-wrap">
        <table className="pt-table">
          <thead>
            <tr>
              <th>Date of service</th>
              <th>Payer</th>
              <th>Status</th>
              <th className="pt-num">Billed</th>
              <th className="pt-num">Paid</th>
              <th className="pt-num">Patient</th>
              <th className="pt-num">Outstanding</th>
            </tr>
          </thead>
          <tbody>
            {claims.map((claim) => (
              <tr
                key={claim.id}
                className={onOpenClaim ? "pt-row-clickable" : undefined}
                onClick={onOpenClaim ? () => onOpenClaim(claim) : undefined}
              >
                <td>{claim.dos || "—"}</td>
                <td>
                  {claim.payer || "—"}
                  {/* The claim keeps the policy it was billed under; it is never
                      retagged. Saying when that policy ended is the whole point. */}
                  {claim.coverage_ended_on && (
                    <span className="pt-chip pt-chip-muted">
                      ended {claim.coverage_ended_on}
                    </span>
                  )}
                </td>
                <td>
                  <span
                    className={`pt-status ${STATUS_CLASS[claim.status] || "pt-status-muted"}`}
                  >
                    {claim.status || "unknown"}
                  </span>
                </td>
                <td className="pt-num">{money(claim.billed)}</td>
                <td className="pt-num">{money(claim.paid)}</td>
                <td className="pt-num">
                  {money(claim.patient_responsibility)}
                </td>
                <td className="pt-num">{money(claim.outstanding)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
